module.exports = function () {
  return new Worker(__webpack_public_path__ + "fce27d7ca2bc93e5d343.worker.js");
};